import GetGatheringForCommentTagSuggestionsDocument from "src/api/graphql/__generated__/documents/GetGatheringForCommentTagSuggestionsDocument";
import useGlobalStore from "src/stores/useGlobalStore";
import { CommentsThreadStoreType } from "../../CommentsThread/stores/commentsThreadStore";

const getGatheringUserTagSuggestions: CommentsThreadStoreType["getUserTagSuggestions"] = async ({
	query,
	limit,
	gatheringId,
	photoId,
}) => {
	if (!gatheringId) return [];
	const { apolloClient } = useGlobalStore.getState();
	if (!apolloClient) return [];

	const { data } = await apolloClient.query({
		query: GetGatheringForCommentTagSuggestionsDocument,
		variables: {
			input: {
				gatheringId,
			},
			usersInput: {
				search: query.toLowerCase().trim(),
				// 1 extra so we can filter out the client user
				limit: limit + 1,
			},
		},
		fetchPolicy: "cache-first",
	});
	const users = data.getGathering?.users?.payload ?? [];

	const retUsers: {
		userId: string;
		firstName: string;
		lastName: string;
	}[] = [];
	const { clientId } = useGlobalStore.getState();
	for (const user of users) {
		if (user.userId && user.firstName && user.lastName && user.userId !== clientId) {
			retUsers.push({
				userId: user.userId,
				firstName: user.firstName,
				lastName: user.lastName,
			});
		}
	}

	return retUsers.slice(0, limit);
};
export default getGatheringUserTagSuggestions;
